/* WaniTas — keuzegenerator engine. Leest de configuratie uit een JSON-blok
   dat de sectie zelf meegeeft (window.WT_GENERATORS), en bouwt daar een
   simpele stap-voor-stap flow van met een terug-knop en een duidelijke
   CTA aan het einde. Alle teksten/foto's/links komen uit de theme-editor. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function taalVanPagina() {
    var lang = (document.documentElement.getAttribute('lang') || 'nl').toLowerCase();
    return lang.indexOf('en') === 0 ? 'en' : 'nl';
  }

  function init(root) {
    if (root.hasAttribute('data-wt-gen-ready')) return; // niet dubbel initialiseren
    var dataEl = root.querySelector('[data-wt-gen-json]');
    if (!dataEl) return;
    root.setAttribute('data-wt-gen-ready', 'true');
    var cfg;
    try {
      cfg = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!cfg || !cfg.stappen || !cfg.stappen.length) return;

    var taal = taalVanPagina();
    var map = {};
    cfg.stappen.forEach(function (s) { map[s.id] = s; });
    if (!map[cfg.start]) cfg.start = cfg.stappen[0].id;

    var stack = [];
    var huidig = cfg.start;

    var stage = root.querySelector('[data-wt-gen-stage]');
    var terugBtn = root.querySelector('[data-wt-gen-terug]');
    var opnieuwBtn = root.querySelector('[data-wt-gen-opnieuw]');
    if (!stage) return;

    function t(v) {
      if (v == null) return '';
      if (typeof v === 'string') return v;
      return v[taal] || v.nl || '';
    }

    function fotoHtml(foto, onderschrift) {
      if (foto) {
        return '<figure class="wt-gen-photo"><img src="' + foto + '" alt="' +
          escapeHtml(t(onderschrift)) + '" loading="lazy"></figure>';
      }
      return '<figure class="wt-gen-photo wt-gen-photo--empty"><span class="wt-gen-photo__ph">' +
        escapeHtml(taal === 'en' ? 'Add a photo here later' : 'Voeg hier later een foto toe') +
        '</span></figure>';
    }

    function renderVraag(node) {
      var html = '<div class="wt-gen-step">';
      if (node.foto) html += fotoHtml(node.foto, node.onderschrift);
      html += '<h2 class="wt-gen-step__vraag">' + escapeHtml(t(node.vraag)) + '</h2>';
      if (node.toelichting) {
        html += '<p class="wt-gen-step__toelichting">' + escapeHtml(t(node.toelichting)) + '</p>';
      }
      html += '<div class="wt-gen-opties">';
      (node.opties || []).forEach(function (o) {
        if (o.link) {
          html += '<a class="wt-btn wt-btn--lg wt-gen-optie" href="' + escapeHtml(o.link) + '">' +
            escapeHtml(t(o.label)) + '</a>';
        } else if (o.doel) {
          html += '<button type="button" class="wt-btn wt-btn--lg wt-gen-optie" data-goto="' +
            escapeHtml(o.doel) + '">' + escapeHtml(t(o.label)) + '</button>';
        }
      });
      html += '</div></div>';
      return html;
    }

    function renderResultaat(node) {
      var html = '<div class="wt-gen-result">';
      if (node.foto) html += fotoHtml(node.foto, node.onderschrift);
      html += '<p class="wt-eyebrow">' + escapeHtml(taal === 'en' ? 'Our advice' : 'Ons advies') + '</p>';
      html += '<h2>' + escapeHtml(t(node.titel)) + '</h2>';
      html += '<div class="wt-gen-advies">' + (t(node.advies) || '') + '</div>';
      html += '<div class="wt-gen-cta">';
      if (node.cta1 && node.cta1.label) {
        html += '<a class="wt-btn wt-btn--lg" href="' + escapeHtml(node.cta1.link || '#') + '">' +
          escapeHtml(t(node.cta1.label)) + '</a>';
      }
      if (node.cta2 && node.cta2.label) {
        html += '<a class="wt-btn wt-btn--lg wt-btn--ghost" href="' + escapeHtml(node.cta2.link || '#') + '">' +
          escapeHtml(t(node.cta2.label)) + '</a>';
      }
      html += '</div></div>';
      return html;
    }

    function bind() {
      stage.querySelectorAll('[data-goto]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var doel = btn.getAttribute('data-goto');
          if (!map[doel]) return;
          stack.push(huidig);
          huidig = doel;
          render();
        });
      });
    }

    function render() {
      var node = map[huidig];
      if (!node) return;
      if (terugBtn) terugBtn.hidden = stack.length === 0;
      stage.innerHTML = node.type === 'resultaat' ? renderResultaat(node) : renderVraag(node);
      bind();
      stage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    if (terugBtn) {
      terugBtn.addEventListener('click', function () {
        if (!stack.length) return;
        huidig = stack.pop();
        render();
      });
    }
    if (opnieuwBtn) {
      opnieuwBtn.addEventListener('click', function () {
        stack = [];
        huidig = cfg.start;
        render();
      });
    }

    render();
  }

  function initAlles(scope) {
    (scope || document).querySelectorAll('[data-wt-generator]').forEach(init);
  }

  ready(function () {
    initAlles(document);
  });

  // De Shopify theme-editor ververst een sectie na een instellingenwijziging
  // door alleen de HTML te vervangen — dat herlaadt de pagina niet en start
  // dus geen nieuw 'DOMContentLoaded'. Zonder dit zou de generator na een
  // wijziging in de live-preview op het oude, eerder gebouwde scherm blijven
  // hangen. Deze events vangen dat op en initialiseren de vervangen sectie
  // opnieuw, zodat de preview altijd de actuele instellingen toont.
  document.addEventListener('shopify:section:load', function (e) {
    initAlles(e.target);
  });
})();
